import { useMemo } from "react"
import { useForm } from "react-hook-form"
import { useTranslation } from "react-i18next"

import { AvaGaebPhase, DEFAULT_AVA_GAEB_PHASE } from "shared/types/AvaGaebPhase"
import { SelectOption } from "shared/types/Select"

import { ProjectGaebOverlayModel } from "../ProjectGaebOverlay"
import { ProjectGaebOverlayViewModel } from "../ProjectGaebOverlayView"

export function useProjectGaebOverlayViewModel({
  onSubmit,
  onCancel
}: ProjectGaebOverlayModel): ProjectGaebOverlayViewModel {
  const { t } = useTranslation()

  const form = useForm({
    defaultValues: { phase: DEFAULT_AVA_GAEB_PHASE }
  })

  const handleSubmit = useMemo(
    () => form.handleSubmit(onSubmit),
    [form.handleSubmit]
  )

  const projectGaebTargetPhaseOptions: SelectOption<AvaGaebPhase>[] = useMemo(
    () => [
      {
        label: t("ProjectExport.GAEBExportOptions.Phase81"),
        value: AvaGaebPhase.PHASE_X81
      },
      {
        label: t("ProjectExport.GAEBExportOptions.Phase84"),
        value: AvaGaebPhase.PHASE_X84
      },
      {
        label: t("ProjectExport.GAEBExportOptions.Phase86"),
        value: AvaGaebPhase.PHASE_X86
      }
    ],
    [t]
  )

  return {
    form,
    options: projectGaebTargetPhaseOptions,
    onSubmit: handleSubmit,
    onCancel
  }
}
